import { useState } from "react";

const faqs = [
  {
    q: "What is the driving range of the eTuatara 1500E on a single charge?",
    a: "The driving range depends on battery configuration and usage conditions, but the eTuatara 1500E is designed to comfortably handle a full day of farm or worksite use on a single charge."
  },
  {
    q: "How long does it take to fully charge the eTuatara 1500E?",
    a: "The vehicle can be charged using a standard 3-pin single-phase power outlet. Overnight charging is typically sufficient to fully recharge the battery."
  },
  {
    q: "Is the eTuatara 1500E suitable for towing and steep terrain?",
    a: "Yes. Because the electric motor delivers full torque at any speed, the eTuatara performs exceptionally well on steep inclines and when towing loads."
  },
  {
    q: "What maintenance is required for the electric model?",
    a: "Electric vehicles require significantly less maintenance than combustion engines. There is no engine oil, fewer moving parts, and lower servicing costs overall."
  },
  {
    q: "Can the vehicle be diagnosed or updated remotely?",
    a: "Yes. The eTuatara supports remote diagnostics and software updates, allowing battery health checks and system updates without visiting a service centre."
  }
];

const NZElectricFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="bg-white pb-[80px]">
      <div className="max-w-[900px] mx-auto px-[20px]">
        <h2 className="text-center kuunari-bold text-[28px] md:text-[36px] mb-[40px]">
          You may still have questions
        </h2>

        <div className="space-y-4">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="border border-[#ccc] rounded-md overflow-hidden"
              >
                <button
                  onClick={() =>
                    setOpenIndex(isOpen ? null : index)
                  }
                  className="w-full flex justify-between items-center px-5 py-4 
                             text-left font-medium text-[#333]"
                >
                  <span>{item.q}</span>

                  {/* Arrow */}
                  <span
                    className={`text-[22px] transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                      }`}
                  >
                    ▾
                  </span>
                </button>

                {isOpen && (
                  <div className="px-5 pb-4 text-[#666] leading-[26px]">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NZElectricFAQ;
